import styled from '@emotion/styled';

import { Scroller } from '../../Scroller';
import { S as ModalStyles } from '../Modal.styles';

const Content = styled(Scroller)(({ theme }) => ({
  position: 'relative',
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  padding: ModalStyles.componentConfig(theme).contentPadding,
}));

export const S = {
  Content,
} as const;
